import { Pill } from "lucide-react";
import ResourcePage from "@/components/ResourcePage";
import { makeAdapter } from "@/lib/supabaseAdapter";

const adapter = makeAdapter({ table: "medications", filterColumn: "profile_id" });

export default function Medications() {
  return (
    <ResourcePage
      config={{
        adapter,
        filterBy: "profile_id",
        slug: "medications",
        eyebrow: "Care",
        title: "Medications",
        description: "Track every dose, schedule, and instruction.",
        icon: Pill,
        accent: "bg-accent/20 text-accent-foreground",
        addLabel: "Add medication",
        testIdPrefix: "med",
        blank: () => ({
          profile_id: "",
          name: "",
          dosage: "",
          frequency: "",
          notes: "",
          start_date: new Date().toISOString().slice(0, 10),
          end_date: "",
          is_active: true,
        }),
        transform: (f, { profile }) => ({
          profile_id: f.profile_id,
          profile_name: profile?.name || null,
          name: f.name,
          dosage: f.dosage,
          frequency: f.frequency,
          notes: f.notes || null,
          start_date: f.start_date || new Date().toISOString().slice(0, 10),
          end_date: f.end_date || null,
          is_active: f.is_active,
        }),
        fields: [
          { key: "name", label: "Medication", required: true, span: 2, placeholder: "e.g. Amoxicillin" },
          { key: "dosage", label: "Dosage", required: true, placeholder: "e.g. 250mg" },
          { key: "frequency", label: "Frequency", required: true, placeholder: "e.g. Twice daily" },
          { key: "start_date", label: "Start date", type: "date", required: true },
          { key: "end_date", label: "End date", type: "date" },
          { key: "notes", label: "Instructions / notes", type: "textarea", placeholder: "Take with food" },
        ],
        render: (m) => (
          <div>
            <div className="font-heading text-lg font-bold leading-tight">{m.name}</div>
            <div className="mt-1 text-sm text-muted-foreground">
              {m.dosage} • {m.frequency}
            </div>
            {m.notes && (
              <div className="mt-3 rounded-lg bg-secondary/40 px-3 py-2 text-xs text-muted-foreground">
                {m.notes}
              </div>
            )}
            {(m.start_date || m.end_date) && (
              <div className="mt-3 text-xs text-muted-foreground">
                {m.start_date || "—"} → {m.end_date || "ongoing"}
              </div>
            )}
          </div>
        ),
      }}
    />
  );
}
